export enum OfficeEquipmentModelSortType {
  Id,
  Name,
  OfficeEquipmentBrandName,
  OfficeEquipmentTypeName,
  IsDeleted
}
